module.exports = __webpack_public_path__ + "static/media/Book_Clan_-_Transparent1.e7ff6f28.png";